import {MultiURL} from 'components/Fields';

const Kafka = () => <MultiURL />;

export default Kafka;
